import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
// import emailValidate from "services/emailValidate";
import validator from "validator";
import swal from "sweetalert";
import api from "services/api";
import { __ } from "services/Translator";

export default function ResetPassword(props) {
  const history = useHistory();
  var params = useParams();
  // const __ = (text) => text;
  const [errors, setErrors] = useState({});

  const [showResetPass, setShowResetPass] = useState(false);

  const toggleShowResetPass = () => {
    if (showResetPass) {
      setShowResetPass(false);
    } else {
      setShowResetPass(true);
    }
  };
  // const params = queryString.parse(window.location.search).p;

  const [changePasswordForm, setChangePasswordForm] = useState({
    user_id: params.userId,
    code: params.code,
    password: "",
    confirm_password: "",
  });
  const [acceptField, setAcceptField] = useState({
    password: 0,
    confirm_password: 0,
  });

  const resetPasswordAction = async (event) => {
    event.preventDefault();
    var valid = validateForm();

    if (valid) {
      var response = await api.post(
        "/reset-password-action",
        changePasswordForm
      );
      // console.log("response", response.data);
      if (response.status == 200) {
        // setAlertMsg({
        //   message: response.data.mainMsg,
        //   variant: "success",
        //   showAlert: true,
        // });

        swal({
          title: "Successful!",
          text: response.data.message,
          icon: "success",
        });

        setChangePasswordForm({
          user_id: params.userId,
          code: params.code,
          password: "",
          confirm_password: "",
        });
        // setTimeout(() => {
        //   setAlertMsg({
        //     message: response.data.mainMsg,
        //     variant: "success",
        //     showAlert: false,
        //   });
        // }, 7000);
      } else if (response.status == 422) {
        if (response.data.errors) {
          setErrors(response.data.errors);
        } else {
          // setAlertMsg({
          //   message: response.data.mainMsg,
          //   variant: "danger",
          //   showAlert: true,
          // });

          swal({
            title: "Error!!",
            text: response.data.message,
            icon: "error",
          });

          // setInterval(() => {
          //   setAlertMsg({
          //     message: response.data.mainMsg,
          //     variant: "danger",
          //     showAlert: false,
          //   });
          // }, 7000);
        }
      }
      // setTimeout(() => {
      //   setAlertMsg({
      //     message: response.data.mainMsg,
      //     variant: "warning",
      //     showAlert: false,
      //   });
      // }, 7000);
    }
  };

  const validateForm = () => {
    var valid = true;

    var errorsTmp = {};

    // if (
    //   validator.isStrongPassword(changePasswordForm.password, {
    //     minLength: 8,
    //     minLowercase: 1,
    //     minUppercase: 1,
    //     minNumbers: 1,
    //     minSymbols: 1,
    //   })
    // ) {
    // } else {
    //   errorsTmp = {
    //     ...errorsTmp,
    //     password:
    //       "Your password must contain between 8 and 30 characters, including at least one number, one special character, one lowercase and one upercase. Do not use your email address or username as your password.",
    //   };
    //   valid = false;
    // }

    if (
      changePasswordForm.password.length < 8 ||
      changePasswordForm.password.length > 30
    ) {
      errorsTmp = {
        ...errorsTmp,
        password: __("Your password must contain between 8 and 30 characters"),
      };
      valid = false;
    }

    if (changePasswordForm.password != changePasswordForm.confirm_password) {
      errorsTmp = {
        ...errorsTmp,
        confirm_password: __("Password does not match"),
      };
      valid = false;
    }

    setErrors(errorsTmp);
    return valid;
  };

  const updateForm = (field, value) => {
    setChangePasswordForm({ ...changePasswordForm, [field]: value });
  };

  const updateInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;

    if (field == "password") {
      if (
        validator.isStrongPassword(value, {
          minLength: 8,
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 1,
        })
      ) {
        setAcceptField({ ...acceptField, password: 1 });
        setErrors({ ...errors, password: "" });
      } else {
        setAcceptField({ ...acceptField, password: 2 });
        setErrors({
          ...errors,
          password: __(
            "Your password must contain between 8 and 30 characters, including at least one number, one special character, one lowercase and one upercase. Do not use your email address or username as your password."
          ),
        });
      }
    }
    if (field == "confirm_password") {
      if (changePasswordForm.password != value) {
        setAcceptField({ ...acceptField, confirm_password: 2 });
        setErrors({ ...errors, confirm_password: "Password does not match" });
      } else {
        setAcceptField({ ...acceptField, confirm_password: 1 });
        setErrors({ ...errors, confirm_password: "" });
      }
    }

    updateForm(field, value);
  };

  const updateSelect = (a, b) => {
    var field = b.name;
    var value = a.value;
    updateForm(field, value);
  };

  const autofocusName = (item) => {
    document.querySelector("#" + item).focus();
  };

  return (
    <>
      <div className="main_popup margin_top_60">
        <div className="container">
          <div className="modal-content ">
            <div className="reg_area">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="login_area_img margin_top_30">
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/login-popup-bg.png?&dpr=1&format=auto&auto=format&w=435&h=496&max-age=2629056"
                    />
                  </div>

                  <div className="logo margin_bottom_30">
                    <img
                      src={
                        require("../../assets/images/new-landing/logo.png")
                          .default
                      }
                      alt="Card-Icon"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <form onSubmit={resetPasswordAction}>
                    <div className="form_area">
                      <div className="form_headline margin_bottom_15">
                        {__("Set your password")}
                      </div>

                      <div className="form margin_bottom_30">
                        <div>
                          <div className="input_group first_child_extend">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("newPassword");
                              }}
                            >
                              {__("New Password")}
                            </div>
                            <input
                              onChange={updateInput}
                              type={showResetPass ? "text" : "password"}
                              name="password"
                              className="input_box focus_border_none"
                              id="newPassword"
                              value={changePasswordForm.password}
                            />
                            <div
                              onClick={toggleShowResetPass}
                              className="show_pass_icon"
                            >
                              <i
                                class={
                                  showResetPass
                                    ? "fas fa-eye-slash"
                                    : "fas fa-eye"
                                }
                              ></i>
                            </div>
                            <div
                              className={
                                acceptField.password == 0
                                  ? "icon "
                                  : acceptField.password == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.password == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">{errors.password}</div>
                        </div>

                        <div>
                          <div className="input_group first_child_extend">
                            <div
                              className="input_label"
                              onClick={() => {
                                autofocusName("confirm_password");
                              }}
                            >
                              {__("Confirm new password")}
                            </div>
                            <input
                              onChange={updateInput}
                              type={showResetPass ? "text" : "password"}
                              name="confirm_password"
                              className="input_box focus_border_none"
                              id="confirm_password"
                              value={changePasswordForm.confirm_password}
                            />
                            <div
                              className={
                                acceptField.confirm_password == 0
                                  ? "icon "
                                  : acceptField.confirm_password == 1
                                  ? "icon success"
                                  : "icon error"
                              }
                            >
                              <i
                                className={
                                  acceptField.confirm_password == 1
                                    ? "fa fa-check"
                                    : "fa fa-times"
                                }
                              ></i>
                            </div>
                          </div>
                          <div className="error_msg">
                            {errors.confirm_password}
                          </div>
                        </div>
                      </div>

                      <div className="submit_btn">
                        <button
                          type="submit"
                          className={"angle_btn in_login " + props.landingType}
                        >
                          Update
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="red"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
